import React from "react";
import "../../styles/PaymentHeader.css";

const PaymentHeader = ({ onRefresh, loading }) => {
    return (
        <div className="payment-header">

            <div className="payment-header-left">

                <h1>Payment Management</h1>

                <p>
                    Manage payments, refunds, settlements and payment
                    transactions.
                </p>

            </div>

            <div className="payment-header-right">

                <button
                    className="refresh-btn"
                    onClick={onRefresh}
                    disabled={loading}
                >
                    {loading ? "Refreshing..." : "Refresh"}
                </button>

            </div>

        </div>
    );
};

export default PaymentHeader;